/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Listings_Filter_SoldInputs */

const en_seller_listings_filter_sold = /** @type {(inputs: Seller_Listings_Filter_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold`)
};

const es_seller_listings_filter_sold = /** @type {(inputs: Seller_Listings_Filter_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendidos`)
};

const fr_seller_listings_filter_sold = /** @type {(inputs: Seller_Listings_Filter_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendues`)
};

const de_seller_listings_filter_sold = /** @type {(inputs: Seller_Listings_Filter_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkauft`)
};

const ja_seller_listings_filter_sold = /** @type {(inputs: Seller_Listings_Filter_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`売却済み`)
};

const zh_seller_listings_filter_sold = /** @type {(inputs: Seller_Listings_Filter_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已售出`)
};

const ar_seller_listings_filter_sold = /** @type {(inputs: Seller_Listings_Filter_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مباع`)
};

const id_seller_listings_filter_sold = /** @type {(inputs: Seller_Listings_Filter_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terjual`)
};

const it_seller_listings_filter_sold = /** @type {(inputs: Seller_Listings_Filter_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venduti`)
};

const ru_seller_listings_filter_sold = /** @type {(inputs: Seller_Listings_Filter_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проданные`)
};

const pt_seller_listings_filter_sold = /** @type {(inputs: Seller_Listings_Filter_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendidos`)
};

const ko_seller_listings_filter_sold = /** @type {(inputs: Seller_Listings_Filter_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매 완료`)
};

/**
* | output |
* | --- |
* | "Sold" |
*
* @param {Seller_Listings_Filter_SoldInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_listings_filter_sold = /** @type {((inputs?: Seller_Listings_Filter_SoldInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Listings_Filter_SoldInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_listings_filter_sold(inputs)
	if (locale === "es") return es_seller_listings_filter_sold(inputs)
	if (locale === "fr") return fr_seller_listings_filter_sold(inputs)
	if (locale === "de") return de_seller_listings_filter_sold(inputs)
	if (locale === "ja") return ja_seller_listings_filter_sold(inputs)
	if (locale === "zh") return zh_seller_listings_filter_sold(inputs)
	if (locale === "ar") return ar_seller_listings_filter_sold(inputs)
	if (locale === "id") return id_seller_listings_filter_sold(inputs)
	if (locale === "it") return it_seller_listings_filter_sold(inputs)
	if (locale === "ru") return ru_seller_listings_filter_sold(inputs)
	if (locale === "pt") return pt_seller_listings_filter_sold(inputs)
	return ko_seller_listings_filter_sold(inputs)
});